import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_USER_DETAILS, SET_USER_DETAILS, USER_DETAILS_REQUEST_FAILED, SENDING_USER_DETAILS_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* userDetails(action) {
  const { data } = action;
  // console.log(data);
  try {
    yield put({
      type: SENDING_USER_DETAILS_REQUEST,
      userDetailsData: '',
      isUserDetailsSending: true,
      isUserDetailsSuccess: false,
      userDetailsError: false,
    });
    const response = yield call(api.users.saveUserDetails, data);
    // console.log(response);
    if (response) {
      // console.log('inside');
      yield put({
        type: SET_USER_DETAILS,
        userDetailsData: response,
        isUserDetailsSending: false,
        userDetailsError: false,
        isUserDetailsSuccess: true,
      });
    } else {
      yield put({
        type: USER_DETAILS_REQUEST_FAILED,
        userDetailsData: null,
        isUserDetailsSending: false,
        userDetailsError: true,
        isUserDetailsSuccess: false,
        userDetailsMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: USER_DETAILS_REQUEST_FAILED,
      userDetailsMsg: e.message,
      isUserDetailsSending: false,
      userDetailsError: true,
      isUserDetailsSuccess: false,
      userDetailsData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchUserDetails() {
  yield takeLatest(GET_USER_DETAILS, userDetails);
}
